import React from 'react'

import { Wrapper } from './styles'

type Props = {
  color?: string
  style?: React.CSSProperties
}

const CloseTreeIcon: React.FC<Props> = ({ color = '#3B7DE9', style }) => {
  return (
    <Wrapper style={style}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg">
        <path d="M6 4.21582L8.90085e-08 7.67992L6.39053e-09 0.751719L6 4.21582Z" />
      </svg>
    </Wrapper>
  )
}

export default CloseTreeIcon
